import "./App.css";
import './styles/index.css';
import 'react-toastify/dist/ReactToastify.css';
import ReactDOM from 'react-dom';
import { Auth0Provider, useAuth0 } from "@auth0/auth0-react";
import * as Sentry from "@sentry/react";
import { Integrations } from "@sentry/tracing";
import { initLogger } from "Logger";
import { StylesProvider } from '@material-ui/core/styles';
import { Route, Router, Switch } from 'react-router-dom';
import { analyticsInitialize, handlePageChange } from 'analytics';
import { LicenseInfo } from '@mui/x-license-pro';
import { createBrowserHistory } from "history";
import MainAppRouter from 'layouts/MainApp';
import { ToastContainer } from 'react-toastify';

// Initialize services
LicenseInfo.setLicenseKey(process.env.REACT_APP_MUI_LICENSE as string);
analyticsInitialize();
initLogger();

/** Browser history instance for routing */
const history = createBrowserHistory();

// Configure Sentry
Sentry.init({
    dsn: process.env.REACT_APP_SENTRY_DSN,
    integrations: [new Integrations.BrowserTracing()],
    tracesSampleRate: 1.0,
    maxBreadcrumbs: 10,
    environment: process.env.NODE_ENV,
});

// Track page changes
history.listen(() => {
    handlePageChange();
});

/** Router component that handles authentication-based routing */
const AppRouter = () => {
    return (
        <>
            <MainAppRouter />
            <ToastContainer />
        </>
    );
};

/** Main application component with providers */
const MainApp = () => {
    const onRedirectCallback = (appState?: any) => {
        console.log('Auth0 redirect callback triggered', { appState, currentUrl: window.location.href });
        // if(appState?.returnTo) {
        //     history.replace(appState.returnTo);
        // }
    };


    return (
        <Auth0Provider
            domain={process.env.REACT_APP_AUTH0_DOMAIN as string}
            clientId={process.env.REACT_APP_AUTH0_CLIENT_ID as string}
            audience={process.env.REACT_APP_AUTH0_AUDIENCE as string}
            scope="openid profile"
            redirectUri={window.location.origin}
            onRedirectCallback={onRedirectCallback}
            useRefreshTokens={true}
            cacheLocation="localstorage"
        >
            <StylesProvider injectFirst>
                <Router history={history}>
                    <AppRouter />
                </Router>
            </StylesProvider>
        </Auth0Provider>
    );
};

ReactDOM.render(
    <MainApp />,
    document.getElementById('root')
);